import { render, staticRenderFns } from "./APIView.vue?vue&type=template&id=3ba1a870&scoped=true&"
import script from "./APIView.vue?vue&type=script&lang=js&"
export * from "./APIView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=3ba1a870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1a870",
  null
  
)

export default component.exports